export default __webpack_public_path__ + "assets/images/22050e74fd8efb8eff97346979e40de7.png";